/**
 * Endorsement Comment Card Component
 * 背书评论卡片组件 - 使用 Swiper.js 实现
 */

if (!customElements.get('endorsement-comment-card')) {
  class EndorsementCommentCard extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.initialSlide = parseInt(this.dataset.initialSlide) || 1;
    }

    connectedCallback() {
      // 等待 Swiper 库加载完成
      this.waitForSwiper();
    }

    waitForSwiper() {
      if (typeof Swiper !== 'undefined') {
        this.initSwiper();
      } else {
        // 如果 Swiper 未加载，等待并重试
        setTimeout(() => this.waitForSwiper(), 100);
      }
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.endorsement-comment-card__swiper');
      
      if (!swiperContainer) {
        console.error('Swiper container not found');
        return;
      }

      // 初始化 Swiper
      this.swiper = new Swiper(swiperContainer, {
        // 基本设置
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 32,
        initialSlide: this.initialSlide,
        
        // 禁用自动播放
        autoplay: false,
        
        // 启用触摸滑动
        touchEventsTarget: 'container',
        simulateTouch: true,
        allowTouchMove: true,
        
        // 循环模式
        loop: false,
        
        // 禁用导航按钮
        navigation: false,
        
        // 禁用分页器
        pagination: false,
        
        // 鼠标滚轮控制
        mousewheel: {
          forceToAxis: true,
        },
        
        // 键盘控制
        keyboard: {
          enabled: true,
        },
        
        // 响应式断点
        breakpoints: {
          // 移动端
          0: {
            slidesPerView: 'auto',
            spaceBetween: 12,
            centeredSlides: true,
          },
          // 平板
          750: {
            slidesPerView: 'auto',
            spaceBetween: 24,
            centeredSlides: true,
          },
          // 桌面端
          1025: {
            slidesPerView: 'auto',
            spaceBetween: 32,
            centeredSlides: true,
          }
        },
        
        // 过渡效果
        speed: 600,
        effect: 'slide',
        
        // 其他配置
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        
        // 允许slides部分超出容器
        watchSlidesProgress: true,
      });

      // 监听窗口大小变化
      window.addEventListener('resize', () => {
        if (this.swiper) {
          this.swiper.update();
        }
      });
    }

    disconnectedCallback() {
      // 组件卸载时销毁 Swiper 实例
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('endorsement-comment-card', EndorsementCommentCard);
}
